enum CabinetRoutesPaths {
	MAIN = "",
	EVENTS = "events",
	MATERIALS = "materials",
	TESTS = "tests",
	TEST = "test",
	TEST_RESULT = "testResult",
	ASSOCIATION = "association",
	EDIT_PROFILE = "registration-two-step",
	NOTIFICATION = "notifications",
	LOYALTY_PROGRAM = "loyaltyProgram",
	DOCUMENTS = "documents",

	USERS = "users",
	ACCESSES_PASSWORD_REQUESTS = "accessesPasswordRequests",
}

export default CabinetRoutesPaths;
